// Auto Generated file, do not modify
import {
    apiDelete,
    apiGet,
    apiPost,
    apiPut,
    ApiRequestOptions,
} from "@redriver/cinnamon-mui";
import {
    MultipleDocumentDownloadRequest,
    UpdateDocumentsVisibilityRequest,
} from "mortar/EnergyEngineering/Endpoints/Documents";
import { DocumentVersionView } from "mortar/EnergyEngineering/Logic/Documents/Views";
import { makeAction, makeFormData } from "../lib";

export interface UpdateDocumentsVisibilityActionRequest {
    request: UpdateDocumentsVisibilityRequest;
    options?: Partial<
        ApiRequestOptions<void, "documents/updateDocumentsVisibility">
    >;
}

export const updateDocumentsVisibility = makeAction((
    { request, options }: UpdateDocumentsVisibilityActionRequest,
) => apiPut<void, "documents/updateDocumentsVisibility">(
    "documents/updateDocumentsVisibility",
    `documents/visibility`,
    request,
    options,
), "documents/updateDocumentsVisibility");

export interface DownloadMultipleDocumentsActionRequest {
    request: MultipleDocumentDownloadRequest;
    options?: Partial<
        ApiRequestOptions<File, "documents/downloadMultipleDocuments">
    >;
}

export const downloadMultipleDocuments = makeAction((
    { request, options }: DownloadMultipleDocumentsActionRequest,
) => apiPost<File, "documents/downloadMultipleDocuments">(
    "documents/downloadMultipleDocuments",
    `documents/zip`,
    request,
    options,
), "documents/downloadMultipleDocuments");

export interface DownloadDocumentRouteParams {
    documentId: string;
}

export interface DownloadDocumentActionRequest {
    routeParams: DownloadDocumentRouteParams;
    options?: Partial<ApiRequestOptions<File, "documents/downloadDocument">>;
}

export const downloadDocument = makeAction((
    { routeParams, options }: DownloadDocumentActionRequest,
) => apiGet<File, "documents/downloadDocument">(
    "documents/downloadDocument",
    `documents/${routeParams.documentId}`,
    undefined,
    options,
), "documents/downloadDocument");

export interface GetDocumentHistoryRouteParams {
    documentId: string;
}

export interface GetDocumentHistoryQueryParams {
    maxResults: number;
}

export interface GetDocumentHistoryActionRequest {
    routeParams: GetDocumentHistoryRouteParams;
    queryParams: GetDocumentHistoryQueryParams;
    options?: Partial<
        ApiRequestOptions<DocumentVersionView[], "documents/getDocumentHistory">
    >;
}

export const getDocumentHistory = makeAction((
    { routeParams, queryParams, options }: GetDocumentHistoryActionRequest,
) => apiGet<DocumentVersionView[], "documents/getDocumentHistory">(
    "documents/getDocumentHistory",
    `documents/${routeParams.documentId}/history`,
    queryParams,
    options,
), "documents/getDocumentHistory");

export interface UploadDocumentVersionRouteParams {
    documentId: string;
}

export interface UploadDocumentVersionActionFormData {
    file: File;
}

export interface UploadDocumentVersionActionRequest {
    routeParams: UploadDocumentVersionRouteParams;
    formParams: UploadDocumentVersionActionFormData;
    formTransform?: (request: UploadDocumentVersionActionFormData) => FormData;
    options?: Partial<
        ApiRequestOptions<void, "documents/uploadDocumentVersion">
    >;
}

export const uploadDocumentVersion = makeAction((
    { routeParams, formParams, formTransform, options }:
        UploadDocumentVersionActionRequest,
) => apiPost<void, "documents/uploadDocumentVersion">(
    "documents/uploadDocumentVersion",
    `documents/${routeParams.documentId}/versions`,
    (formTransform || makeFormData)(formParams, {
        file: "Append",
    }),
    { contentType: null, ...options },
), "documents/uploadDocumentVersion");

export interface DownloadDocumentVersionRouteParams {
    documentId: string;
    versionId: string;
}

export interface DownloadDocumentVersionActionRequest {
    routeParams: DownloadDocumentVersionRouteParams;
    options?: Partial<
        ApiRequestOptions<File, "documents/downloadDocumentVersion">
    >;
}

export const downloadDocumentVersion = makeAction((
    { routeParams, options }: DownloadDocumentVersionActionRequest,
) => apiGet<File, "documents/downloadDocumentVersion">(
    "documents/downloadDocumentVersion",
    `documents/${routeParams.documentId}/versions/${routeParams.versionId}`,
    undefined,
    options,
), "documents/downloadDocumentVersion");

export interface RevertDocumentVersionRouteParams {
    documentId: string;
    versionId: string;
}

export interface RevertDocumentVersionActionRequest {
    routeParams: RevertDocumentVersionRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "documents/revertDocumentVersion">
    >;
}

export const revertDocumentVersion = makeAction((
    { routeParams, options }: RevertDocumentVersionActionRequest,
) => apiPost<void, "documents/revertDocumentVersion">(
    "documents/revertDocumentVersion",
    `documents/${routeParams.documentId}/versions/${routeParams.versionId}/revert`,
    undefined,
    options,
), "documents/revertDocumentVersion");
